require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./alla-debattinlagg.json") })
        }
      }, "path---alla-debattinlagg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---alla-debattinlagg!./.cache/json/alla-debattinlagg.json
// module id = 483
// module chunks = 231608221292675